(function () {
    var root = document.querySelector('[data-bd]');
    if (!root) return;

    var panel   = root.querySelector('.bd__panel');
    var barEl   = root.querySelector('[data-bd-bar]');
    var bodyEl  = root.querySelector('[data-bd-body]');
    var upsellEl = root.querySelector('[data-bd-upsell]');
    var scrimEl = root.querySelector('[data-bd-collapse]');
    var slotsEl = root.querySelector('[data-bd-slots]');
    var ladderEl = root.querySelector('[data-bd-ladder]');
    var stripEl = root.querySelector('[data-bd-strip]');
    var countEl = root.querySelector('[data-bd-count]');
    var linesEl = root.querySelector('[data-bd-lines]');
    var emptyEl = root.querySelector('[data-bd-empty]');
    var pitchEl = root.querySelector('[data-bd-pitch]');
    // Measured, not assumed. See the note where the pitch is built.
    var FREE_AT = 4;
    var totalEl = root.querySelector('[data-bd-total]');
    var saveEl  = root.querySelector('[data-bd-save]');
    var toggleEl = root.querySelector('[data-bd-toggle]');
    var upHead  = root.querySelector('[data-bd-uphead]');
    var recsEl  = root.querySelector('[data-bd-recs]');

    var SMALL = root.dataset.smallSizes.split(',').map(function (s) { return s.trim().toLowerCase(); });
    var FLAT  = Math.round(parseFloat(root.dataset.flatPrice) * 100);
    var T2    = parseFloat(root.dataset.tier2) / 100;
    var T3    = parseFloat(root.dataset.tier3) / 100;
    var SLOTS = parseInt(root.dataset.slots, 10) || 4;
    // The switch. Off, nothing in this file computes a price: every figure on
    // screen is read straight out of /cart.js. On, the browser previews the
    // tiers and the preview disclaimer is in the markup alongside them.
    var TIERS = root.dataset.tiers === 'true';
    var FWD   = parseInt(root.dataset.forward, 10);
    if (!(FWD > 0)) FWD = 2;
    var UPSELL_ON = root.dataset.upsell === 'true';
    var UP_COUNT  = parseInt(root.dataset.upsellCount, 10) || 4;
    var CART_URL  = root.dataset.cartUrl || '/cart';
    var SEEN_KEY  = 'prntd:bd:upsell-seen';
    var money = new Intl.NumberFormat(undefined, { style: 'currency', currency: root.dataset.currency || 'USD' });

    var mode = 'collapsed';   // collapsed | open | upsell
    var prevUnitCount = 0;
    var lastCart = null;
    var recs = null;          // null = not fetched, [] = nothing usable
    var recsSourceId = null;

    function fmt(cents) { return money.format((cents || 0) / 100); }
    function isSmall(v) { return SMALL.indexOf(String(v || '').trim().toLowerCase()) !== -1; }
    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    // Expand cart lines into individual units. Ranked most expensive first
    // only when the tiers need ranking; otherwise the bucket keeps cart order,
    // so the poster just added is the one on the end of the strip.
    // 6x9 club prints are their own $5.55 deal and sit outside buy 2 get 2,
    // so they never count toward the ladder.
    // A club print is now the 6x9 size of any poster (snippets/prntd-is-6x9);
    // the old separate Club Print product is still recognised.
    function isClubSize(v) {
      var t = String((v && (v.variant_title || v.title || v.public_title)) || '').split(' / ')[0]
        .toLowerCase().replace(/inches|inch|in|\s|"|\u201d/g, '');
      return t === '6x9';
    }
    function isClub(item) {
      return item.product_type === 'Club Print' || String(item.handle || '').indexOf('club-print') !== -1 ||
        isClubSize({ variant_title: item.variant_title });
    }
    function offerCount(cart) {
      var n = 0;
      cart.items.forEach(function (item) { if (!isClub(item)) n += item.quantity; });
      return n;
    }

    function unitsFrom(cart, rank) {
      var units = [];
      cart.items.forEach(function (item) {
        if (isClub(item)) return;
        for (var i = 0; i < item.quantity; i++) {
          units.push({
            key: item.key,
            title: item.product_title || item.title,
            variant: item.variant_title || '',
            image: item.image || '',
            price: item.price
          });
        }
      });
      if (rank) units.sort(function (a, b) { return b.price - a.price; });
      return units;
    }

    function priceUnit(unit, rank) {
      if (rank === 0) return { price: unit.price, label: '' };
      if (rank === 1) return { price: Math.round(unit.price * (1 - T2)), label: Math.round(T2 * 100) + '% OFF' };
      if (rank === 2) return { price: Math.round(unit.price * (1 - T3)), label: Math.round(T3 * 100) + '% OFF' };
      if (isSmall(unit.variant) && FLAT < unit.price) return { price: FLAT, label: fmt(FLAT) };
      return { price: Math.round(unit.price * (1 - T3)), label: Math.round(T3 * 100) + '% OFF' };
    }

    function ordinal(n) {
      var s = ['th', 'st', 'nd', 'rd'], v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    }

    // What a forward slot advertises. Only rank 3 and up names an amount,
    // because that tier is a flat price. The percentage tiers depend on which
    // poster gets added, so they stay percentages.
    function slotReward(rank) {
      if (rank === 0) return { big: '1st', cap: 'Full price', capLong: 'Full price' };
      if (rank === 1) return { big: '-' + Math.round(T2 * 100) + '%', cap: '2nd', capLong: '2nd poster' };
      if (rank === 2) return { big: '-' + Math.round(T3 * 100) + '%', cap: '3rd', capLong: '3rd poster' };
      return { big: fmt(FLAT), cap: 'small', capLong: ordinal(rank + 1) + ', small size' };
    }

    /* The offer, measured on the live cart one quantity at a time:
         4 in the cart  pay 2  2 free    buy 2 get 2
         6 in the cart  pay 3  3 free    buy 3 get 3
         8 in the cart  pay 4  4 free    buy 4 get 4
       Every step adds one paid poster and one free one. */
    var LADDER = [
      { at: 8, buy: 4, free: 4 },
      { at: 6, buy: 3, free: 3 },
      { at: 4, buy: 2, free: 2 }
    ];

    /* The posters already in the cart are coloured in, so each step reads as
       a progress bar made of posters rather than as a price list: solid ink
       for one they have paid for, solid cyan for one they have unlocked free,
       and the pale or dashed versions for what is still to come. */
    /* What one more step costs, from where this cart actually stands.
       The ladder used to carry a general rule, "add 2 more posters at any step
       and one of them is free", which is true of moving from one step to the
       next and false at the point most people read it: with two in the cart,
       the next two are BOTH free. A general rule that is wrong in the most
       common case is worse than no rule, so both the bar and the ladder now
       state this cart's own next move. */
    function offerLine(total, reached, next, long) {
      if (!next) {
        return long
          ? 'This is the best tier. <strong>' + (reached ? reached.free : 4) + '</strong> of these posters are free.'
          : '<strong>' + (reached ? reached.free : 4) + ' free</strong> in this order. Best tier reached';
      }
      var needMore = next.at - total;
      var payMore = Math.max(0, needMore - (next.free - (reached ? reached.free : 0)));
      if (total === 0) {
        return long
          ? 'Add <strong>4 posters</strong> and you pay for <strong>2</strong> of them.'
          : 'Add <strong>4</strong> posters, pay for <strong>2</strong>';
      }
      var noun = needMore === 1 ? 'poster' : 'posters';
      if (payMore === 0) {
        var free = needMore === 1 ? 'it is <strong>free</strong>' : 'both are <strong>free</strong>';
        return long
          ? 'Add <strong>' + needMore + ' more</strong> ' + noun + ' and ' + free + '.'
          : 'Add <strong>' + needMore + ' more</strong>, ' + (needMore === 1 ? 'it is <strong>free</strong>' : 'both <strong>free</strong>');
      }
      return long
        ? 'Add <strong>' + needMore + ' more</strong> ' + noun + ' and you pay for <strong>' + payMore + '</strong> of them.'
        : 'Add <strong>' + needMore + ' more</strong>, pay for <strong>' + payMore + '</strong>';
    }

    function ladderStepHTML(step, state, total) {
      var have = Math.min(total, step.buy + step.free);
      var minis = '';
      for (var i = 0; i < step.buy; i++) {
        minis += '<span class="bd__mini bd__mini--' + (i < have ? 'have' : 'paid') + '"></span>';
      }
      for (var j = 0; j < step.free; j++) {
        minis += '<span class="bd__mini bd__mini--' + (step.buy + j < have ? 'havefree' : 'free') + '"></span>';
      }
      return '<div class="bd__step bd__step--' + state + '">' +
        '<span class="bd__stepminis">' + minis + '</span>' +
        '<span class="bd__steplabel">Buy ' + step.buy + ', get <b>' + step.free + ' free</b></span>' +
        (state === 'done' ? '<span class="bd__steptick" aria-hidden="true">\u2713</span>' : '') +
      '</div>';
    }

    /* Drawn cheapest step first, which is the order a customer climbs it. */
    function renderLadder(total, reached, next) {
      if (!ladderEl) return;
      var steps = LADDER.slice().reverse();
      var html = '';
      for (var i = 0; i < steps.length; i++) {
        var st = steps[i];
        var state = total >= st.at ? 'done' : (next && next.at === st.at ? 'now' : 'later');
        html += ladderStepHTML(st, state, total);
      }
      var foot = offerLine(total, reached, next, true);
      ladderEl.innerHTML = '<div class="bd__steps">' + html + '</div>'
        + '<p class="bd__ladderfoot">' + foot + '</p>';
      ladderEl.hidden = false;
    }

    function nextPitch(count) {
      if (count === 0) return 'Add a poster. Every one after that gets cheaper.';
      if (count === 1) return 'Add <b>1 more</b> and your second poster is <b>' + Math.round(T2 * 100) + '% off</b>.';
      if (count === 2) return 'Add <b>1 more</b> and your third is <b>' + Math.round(T3 * 100) + '% off</b>.';
      if (count === 3) return 'Add <b>1 more</b> small poster for just <b>' + fmt(FLAT) + '</b>.';
      return 'Every extra small poster is <b>' + fmt(FLAT) + '</b>.';
    }

    // Plain text version of the same promise, for the upsell headline.
    function nextRewardText(count) {
      if (count === 1) return 'Your next poster is ' + Math.round(T2 * 100) + '% off';
      if (count === 2) return 'Your next poster is ' + Math.round(T3 * 100) + '% off';
      if (count >= 3) return 'Another small poster is ' + fmt(FLAT);
      return 'Start your bundle';
    }

    /* Size the slots to the room there is. In the slim bar the strip is about
       170px wide: four posters and two empty slots at the full 44px would need
       300px, so they are drawn smaller instead of some of them being dropped.
       Floored at 20px, where a poster thumbnail is still recognisable, and
       never larger than the 44px the strip is designed around. */
    function fitSlots(count) {
      if (TIERS || mode !== 'collapsed' || !count) {
        slotsEl.style.removeProperty('--bd-slot');
        slotsEl.style.removeProperty('--bd-gap');
        slotsEl.removeAttribute('data-tight');
        slotsEl.removeAttribute('data-wall');
        return;
      }
      var avail = slotsEl.clientWidth;
      if (!avail) return;
      /* Measured at 402px: the strip has about 170px. Six slots fit at 23px
         with 3px gaps; eight need 18px and 2px, which still reads as a row of
         posters rather than as dots. Below that it scrolls rather than
         shrinking into confetti. */
      /* Owner 2026-10-13: 18px tiles read as dots. Posters stay poster
         shaped (2:3, see .bd__slots[data-wall]) and never go below 28px wide;
         past that the strip scrolls like a little wall. */
      var gap = count > 5 ? 4 : 5;
      var floor = 28;
      var size = Math.floor((avail - gap * (count - 1) - 14) / count);
      size = Math.max(floor, Math.min(44, size));
      slotsEl.style.setProperty('--bd-slot', size + 'px');
      slotsEl.style.setProperty('--bd-gap', gap + 'px');
      if (size < 34) slotsEl.setAttribute('data-tight', ''); else slotsEl.removeAttribute('data-tight');
      slotsEl.setAttribute('data-wall', '');
    }
    window.addEventListener('resize', function () { if (lastCart) render(lastCart); });

    function markFades() {
      var max = slotsEl.scrollWidth - slotsEl.clientWidth;
      if (max > 4) {
        if (slotsEl.scrollLeft > 4) stripEl.setAttribute('data-more-left', ''); else stripEl.removeAttribute('data-more-left');
        if (slotsEl.scrollLeft < max - 4) stripEl.setAttribute('data-more-right', ''); else stripEl.removeAttribute('data-more-right');
      } else {
        stripEl.removeAttribute('data-more-left');
        stripEl.removeAttribute('data-more-right');
      }
    }
    slotsEl.addEventListener('scroll', markFades, { passive: true });

    // Park the "Next" slot about a third of the way along the strip. Right
    // aligning it, which is what this used to do, pushed every poster the
    // customer already owns off the left edge; on the product page the strip is
    // only a few slots wide and the bucket then read as all empty promises.
    function scrollToNext() {
      var next = slotsEl.querySelector('.bd__slot--next');
      if (!next) {
        // Tiers off: there is no reward slot to park, so the strip ends on the
        // poster most recently added instead of on the oldest one.
        if (!TIERS) slotsEl.scrollLeft = slotsEl.scrollWidth;
        markFades();
        // Thumbnails are still loading when render runs, so the strip has not
        // finished sizing yet and the edge fade was being decided against a
        // width it never keeps.
        requestAnimationFrame(markFades);
        return;
      }
      var lead = mode === 'collapsed' ? 6 : Math.round(slotsEl.clientWidth * 0.36);
      var want = next.offsetLeft - lead;
      var max = slotsEl.scrollWidth - slotsEl.clientWidth;
      slotsEl.scrollLeft = Math.min(Math.max(0, want), Math.max(0, max));
      markFades();
      requestAnimationFrame(markFades);
    }

    // Reserve exactly the collapsed height at the foot of the page so the bar
    // never hides content permanently.
    var padded = 0;

    // How far off the floor this bar is sitting, in px. Non zero only when the
    // host page owns the bottom edge and set --prntd-dock-bottom.
    function dockPx() {
      var n = parseFloat(getComputedStyle(root).bottom);
      return isFinite(n) && n > 0 ? n : 0;
    }

    // Compact layout while docked, so the two stacked bars stay a strip and
    // not a wall. Re-read on resize because the host only docks on phones.
    function syncDock() {
      root.classList.toggle('bd--docked', dockPx() > 0);
    }

    function syncPad() {
      if (root.hidden) {
        if (padded) { document.body.style.paddingBottom = ''; padded = 0; }
        return;
      }
      if (mode !== 'collapsed') return;
      // The host bar underneath already reserves its own height, so the foot
      // has to clear both or the last line of the page hides behind them.
      var h = Math.round(panel.getBoundingClientRect().height + dockPx());
      if (h && h !== padded) { document.body.style.paddingBottom = h + 'px'; padded = h; }
    }

    function setMode(next) {
      mode = next;
      barEl.classList.remove('bd__bar--flash');
      root.classList.toggle('is-open', next !== 'collapsed');
      bodyEl.hidden = next !== 'open';
      // Drives the rule that stands the bar's thumbnail strip down while the
      // card rail is showing the same posters.
      root.classList.toggle('is-expanded', next === 'open');
      upsellEl.hidden = next !== 'upsell';
      scrimEl.hidden = next === 'collapsed';
      toggleEl.setAttribute('aria-expanded', next === 'open' ? 'true' : 'false');
      toggleEl.setAttribute('aria-label', next === 'open' ? 'Hide cart details' : 'Show cart details');
      document.body.style.overflow = next === 'collapsed' ? '' : 'hidden';
      // The host page hides its own bottom bar while the sheet is up, so the
      // sheet is never sitting on a stranded strip of someone else's chrome.
      document.documentElement.classList.toggle('bd-sheet-open', next !== 'collapsed');
      if (next === 'collapsed') { syncDock(); requestAnimationFrame(syncPad); }
      // The strip shows fewer posters in the slim bar than in the sheet, so it
      // is rebuilt rather than only re-aimed.
      if (lastCart) render(lastCart);
      setTimeout(scrollToNext, 240);
    }

    /* The header badge is server rendered and only the theme's own product
       form re-renders it. The product page buy box and this sheet's own
       quantity buttons change the cart without it, so a fourth poster left
       the badge reading 3 while the sheet said 4. Every render here has just
       read /cart.js, so it keeps the badge honest from the same numbers. */
    function syncHeaderCount(cart) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (!bubble || !cart) return;
      var n = cart.item_count || 0;
      var badge = bubble.querySelector('.header__cart-count');
      if (!n) { if (badge) badge.remove(); return; }
      if (!badge) {
        badge = document.createElement('div');
        badge.className = 'header__cart-count absolute bg-theme-text text-theme-bg text-center';
        badge.innerHTML = '<span aria-hidden="true" class="header__cart-count-number"></span><span class="visually-hidden"></span>';
        bubble.appendChild(badge);
      }
      var num = badge.querySelector('[aria-hidden]');
      if (num && n < 10000) num.textContent = n;
      var sr = badge.querySelector('.visually-hidden');
      if (sr) sr.textContent = n + (n === 1 ? ' item' : ' items');
    }

    function render(cart) {
      lastCart = cart;
      syncHeaderCount(cart);
      var units = unitsFrom(cart, TIERS);
      var isNew = units.length > prevUnitCount;
      prevUnitCount = units.length;

      // The bar only exists once there is something in the cart.
      root.hidden = units.length === 0 && mode === 'collapsed';
      syncDock();

      emptyEl.hidden = units.length > 0;
      // The next reward line is a claim about price. It exists only with the
      // preview behind it.
      /* ---------- the offer, as measured ----------
         The store runs a buy-and-get-free promotion through an app, not as a
         native Shopify discount, so nothing in the theme knew about it and
         the cart said nothing about it at all.

         Measured against the live cart on 2026-09-13:
           1 poster  $11.95   no discount
           2 posters $23.90   no discount
           3 posters $35.85   no discount
           3 mixed   $58.85   no discount
           4 posters          two of them free, you pay for the dearest two

         So the threshold is four, and below four the shopper is getting
         nothing while believing the banner. Saying exactly how many more are
         needed is the single most valuable sentence in this drawer. Above the
         threshold we stop selling and simply report what the cart itself says
         is free, so the message can never overstate the offer. */
      var freeLines = 0;
      for (var fi = 0; fi < cart.items.length; fi++) {
        if (cart.items[fi].final_line_price === 0) freeLines += cart.items[fi].quantity;
      }
      var totalUnits = offerCount(cart);
      var reached = null, next = null;
      for (var ti = 0; ti < LADDER.length; ti++) {
        if (totalUnits >= LADDER[ti].at) { reached = LADDER[ti]; break; }
      }
      for (var tj = LADDER.length - 1; tj >= 0; tj--) {
        if (totalUnits < LADDER[tj].at) { next = LADDER[tj]; break; }
      }
      if (!TIERS) renderLadder(totalUnits, reached, next);
      if (TIERS) {
        pitchEl.hidden = false;
        pitchEl.innerHTML = nextPitch(units.length);
      } else if (totalUnits >= 0) {
        /* The real ladder, measured on the live cart one quantity at a time:

             4 in the cart  pay 2  2 free     buy 2 get 2
             6 in the cart  pay 3  3 free     buy 3 get 3
             8 in the cart  pay 4  4 free     buy 4 get 4

           An earlier version of this said "add 3 more and 2 are free" because
           the test that produced it stopped at five items and read the cap as
           two. It is not a cap: every even step adds another free poster up to
           four. Understating the offer at the moment someone is deciding is
           the most expensive copy mistake available here. */
        /* Both halves when both are true. An earlier version stopped selling
           the moment anything went free: at four in the cart it said "2 free
           in this order" and never mentioned that two more posters make it
           three free. Saying what they have AND what is one step away is the
           whole job of this line. */
        /* Phrasing, corrected. With one poster in the cart this line read
           "Add 3 more \u2192 2 free", which a customer reads as three more to pay
           for. What actually happens is that they choose three more posters
           and one of the four is added to the bill. So the line says what it
           costs, not what it counts: "Add 3 more, pay for 1". */
        pitchEl.hidden = false;
        if (next || reached) {
          pitchEl.innerHTML = offerLine(totalUnits, reached, next, false);
        } else {
          pitchEl.hidden = true;
          pitchEl.innerHTML = '';
        }
      } else {
        pitchEl.hidden = true;
        pitchEl.innerHTML = '';
      }

      // Filled slots, then always at least FWD greyed forward slots, and never
      // fewer than the configured slot count in total. Tiers off, the strip
      // stops at the posters actually in the cart: an empty slot is only
      // meaningful as the reward it unlocks.
      /* The slim bar shows the whole cart, not a sample of it. Hiding posters
         behind a count made a cart of four look like a cart of two, and the
         point of this strip is that a customer can see their own basket
         against what one more poster unlocks. It fits by sizing the slots to
         the width available rather than by dropping any of them. */
      var slim = !TIERS && mode === 'collapsed';
      /* Four of the same poster is one card in the cart, and drawing it four
         times spent the strip's whole width restating it. In the slim bar a
         line is one slot carrying its own count; in the sheet, where there is
         room, every poster keeps its own slot. */
      var list = units;
      if (slim) {
        list = cart.items.map(function (it) {
          return {
            key: it.key, title: it.product_title || it.title,
            variant: it.variant_title || '', image: it.image || '',
            price: it.price, qty: it.quantity,
            free: it.final_line_price === 0
          };
        });
      }
      var slotHTML = '';
      /* The empty slots the next step is made of: the ones still to be paid
         for, then the ones that come free. At two in the cart that is two FREE
         slots and nothing else, which is the offer drawn rather than written.
         Counted from the ladder, never invented: needed is the gap to the next
         step and freeGain is what that step adds over the one already
         reached. */
      var ghosts = [];
      if (!TIERS && next) {
        var needed = Math.max(0, next.at - totalUnits);
        var freeGain = next.free - (reached ? reached.free : 0);
        var freeGhosts = Math.min(needed, Math.max(0, freeGain));
        var payGhosts = needed - freeGhosts;
        for (var gp = 0; gp < payGhosts; gp++) ghosts.push('add');
        for (var gf = 0; gf < freeGhosts; gf++) ghosts.push('free');
      }
      var shown = TIERS ? Math.max(SLOTS, units.length + FWD) : list.length;
      for (var i = 0; i < shown; i++) {
        var u = list[i];
        if (u) {
          var newest = isNew && i === list.length - 1 ? ' bd__slot--new' : '';
          var badge = '';
          if (TIERS) {
            var p = priceUnit(u, i);
            // Short badge text: 44px of card cannot hold "20% OFF" without
            // clipping it to "20% 0...".
            var short = p.label ? p.label.replace(/^(\d+)% OFF$/, '-$1%') : 'FULL';
            badge = p.label
              ? '<span class="bd__slotbadge">' + short + '</span>'
              : '<span class="bd__slotbadge bd__slotbadge--plain">' + short + '</span>';
          }
          slotHTML += '<div class="bd__slot bd__slot--filled' + (u.free ? ' bd__slot--won' : '') + newest + '" title="' + esc(u.title) + (u.free ? ' (free)' : '') + '">' +
            (u.image ? '<img src="' + esc(u.image) + '" alt="" loading="lazy">' : '') +
            (u.qty > 1 ? '<span class="bd__slotqty">' + u.qty + '</span>' : '') +
            (u.free ? '<span class="bd__slotwon">FREE</span>' : '') +
            badge +
          '</div>';
        } else {
          var r = slotReward(i);
          // The first empty slot is the reward one more poster unlocks; the
          // ones past it are the forward look, greyed back.
          var isNext = i === list.length;
          var mod = isNext ? ' bd__slot--next' : ' bd__slot--future';
          slotHTML += '<div class="bd__slot bd__slot--empty' + mod + '" title="' + esc(r.capLong) + '">' +
            (isNext ? '<span class="bd__slotnext">Next</span>' : '') +
            '<span class="bd__slotbig">' + r.big + '</span>' +
            '<span class="bd__slotcap" data-cap="' + esc(r.cap) + '" data-cap-long="' + esc(r.capLong) + '"></span>' +
          '</div>';
        }
      }
      for (var gi = 0; gi < ghosts.length; gi++) {
        var isFree = ghosts[gi] === 'free';
        var first = gi === 0 ? ' bd__slot--next' : '';
        slotHTML += '<div class="bd__slot bd__slot--empty bd__slot--' + (isFree ? 'freeslot' : 'addslot') + first + '" '
          + 'title="' + (isFree ? 'Free at ' + next.at + ' posters' : 'Add one more poster') + '">'
          + '<span class="bd__slotbig">' + (isFree ? 'FREE!' : '+1') + '</span>'
          + '<span class="bd__slotcap" data-cap="' + (isFree ? 'free' : 'add')
          + '" data-cap-long="' + (isFree ? 'free at ' + next.at : 'add one more') + '"></span>'
        + '</div>';
      }
      slotsEl.innerHTML = slotHTML;
      /* Three times: the strip is often still 0px wide on the first pass,
         because the bar mounts hidden and is revealed a frame later. A measure
         taken then silently leaves the slots at full size and the strip
         scrolling, which is the bug this whole change was fixing. */
      var wantedSlots = list.length + ghosts.length;
      fitSlots(wantedSlots);
      requestAnimationFrame(function () { fitSlots(wantedSlots); });
      window.setTimeout(function () { fitSlots(wantedSlots); }, 300);
      // Split so the suffix can go when the bar is docked. Measured at 320px,
      // " . total" was taking 45 of the 204px the docked row has to share
      // between the bucket, the total and the chevron.
      countEl.innerHTML = (units.length === 1 ? '1 poster' : units.length + ' posters') +
        '<span class="bd__totsuf"> \u00b7 total</span>';
      scrollToNext();

      // Per line price. Tiers off it is the line's own final price out of the
      // cart, which is what Shopify will charge for it, automatic store
      // discounts included. Tiers on it is the preview, with the undiscounted
      // price struck through beside it.
      var priceFor = {};
      if (TIERS) {
        var perKey = {};
        var total = 0, wasTotal = 0;
        units.forEach(function (u, i) {
          var p = priceUnit(u, i);
          total += p.price; wasTotal += u.price;
          if (!perKey[u.key]) perKey[u.key] = { now: 0, was: 0 };
          perKey[u.key].now += p.price;
          perKey[u.key].was += u.price;
        });
        cart.items.forEach(function (item) {
          var g = perKey[item.key];
          if (!g) return;
          priceFor[item.key] = (g.now < g.was ? '<span class="bd__was">' + fmt(g.was) + '</span>' : '') + fmt(g.now);
        });
        var saved = wasTotal - total;
        saveEl.hidden = saved <= 0;
        saveEl.textContent = 'Saving ' + fmt(saved);
        totalEl.textContent = fmt(total);
      } else {
        cart.items.forEach(function (item) {
          // A line the store is charging nothing for. "$0.00" on its own reads
          // as a broken template, so it says what it is. Still the cart's own
          // figure, not one worked out here.
          priceFor[item.key] = (item.final_line_price === 0 && item.original_line_price > 0)
            ? 'Free'
            : fmt(item.final_line_price);
        });
        saveEl.hidden = true;
        saveEl.textContent = '';
        // The real total, straight from the cart. Not a sum computed here, so
        // whatever Shopify has already taken off is already in it.
        totalEl.textContent = fmt(cart.total_price);
      }

      // Cards, not rows. A poster is a picture, and a vertical list of four
      // of them is a scroll; a left to right rail shows the whole wall at
      // once, which is the thing being built. The title and the remove
      // control live behind a tap on the card, so the resting state carries
      // only what a shopper checks: which poster, what size, what it costs,
      // how many.
      linesEl.innerHTML = cart.items.map(function (item) {
        if (priceFor[item.key] == null) return '';
        var free = /^free$/i.test(String(priceFor[item.key]).replace(/<[^>]*>/g, '').trim());
        return '<article class="bd__card' + (free ? ' bd__card--free' : '') + '" data-bd-card="' + esc(item.key) + '">' +
          '<button class="bd__cardTap" type="button" data-bd-expand="' + esc(item.key) + '" aria-expanded="false" aria-label="Details for ' + esc(item.product_title) + '">' +
            (item.image ? '<img src="' + esc(item.image) + '" alt="" loading="lazy">' : '<span class="bd__cardNoimg"></span>') +
          '</button>' +
          '<button class="bd__cardX" type="button" data-bd-remove="' + esc(item.key) + '" aria-label="Remove ' + esc(item.product_title) + '" tabindex="-1">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>' +
          '</button>' +
          '<div class="bd__cardName">' + esc(item.product_title) + '</div>' +
          '<div class="bd__cardMeta">' +
            '<span class="bd__cardSize">' + esc(item.variant_title || '') + '</span>' +
            '<span class="bd__cardPrice">' + priceFor[item.key] + '</span>' +
          '</div>' +
          '<div class="bd__cardQty">' +
            '<button class="bd__qbtn bd__qbtn--dec" type="button" data-bd-dec="' + esc(item.key) + '" aria-label="Remove one">' +
              '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h14" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg>' +
            '</button>' +
            '<span class="bd__qnum">' + item.quantity + '</span>' +
            '<button class="bd__qbtn bd__qbtn--inc" type="button" data-bd-inc="' + esc(item.key) + '" aria-label="Add one">' +
              '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg>' +
            '</button>' +
          '</div>' +
        '</article>';
      }).join('');

      linesEl.querySelectorAll('[data-bd-expand]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = btn.closest('.bd__card');
          var open = card.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          var x = card.querySelector('.bd__cardX');
          if (x) x.tabIndex = open ? 0 : -1;
        });
      });
      syncPad();
      requestAnimationFrame(syncPad);
      prefetchRecs(cart);
    }

    /* ---------- upsell ---------- */

    function seen() {
      try { return sessionStorage.getItem(SEEN_KEY) === '1'; } catch (e) { return false; }
    }
    function markSeen() {
      try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
    }

    // Posters are sized "11x16.5", "24x36" and so on. Anything else on this
    // store is an add-on such as shipping protection, never a suggestion.
    var SIZE_RE = /^\s*\d+(\.\d+)?\s*x\s*\d+(\.\d+)?\s*$/i;
    function cheapestVariant(product) {
      var best = null;
      (product.variants || []).forEach(function (v) {
        if (v.available === false) return;
        if (isClubSize(v)) return;
        if (!SIZE_RE.test(String(v.title || ''))) return;
        if (!best || v.price < best.price) best = v;
      });
      return best;
    }

    function img(src, w) {
      if (!src) return '';
      var s = String(src);
      if (s.indexOf('//') === 0) s = 'https:' + s;
      return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }

    // Fetched ahead of the click so the cart button never waits on the network.
    function prefetchRecs(cart) {
      if (!UPSELL_ON || seen()) return;
      if (!cart.items || !cart.items.length) return;
      var seed = cart.items.slice().sort(function (a, b) { return b.price - a.price; })[0];
      var pid = seed.product_id;
      if (!pid || pid === recsSourceId) return;
      recsSourceId = pid;
      var inCart = {};
      cart.items.forEach(function (it) { inCart[it.product_id] = true; });

      fetch('/recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&limit=10&intent=related', {
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (data) {
          var out = [];
          (data.products || []).forEach(function (p) {
            if (out.length >= UP_COUNT) return;
            if (inCart[p.id]) return;
            // One tap adds from here, so nothing that needs a photo or sits
            // outside the offer: the custom upload and the club print.
            if (/(^|-)custom(-|$)|club-print/.test(p.handle || '')) return;
            if (p.type === 'Club Print' || (p.tags || []).indexOf('club-6x9') !== -1) return;
            var v = cheapestVariant(p);
            if (!v) return;
            out.push({ id: p.id, title: p.title, image: p.featured_image, variant: v });
          });
          recs = out;
        })
        .catch(function () { recs = []; });
    }

    function showUpsell(count) {
      // Tiers off there is no reward to name, so the ask is just an ask. The
      // prices in the list below are the variants' own, not a preview.
      upHead.innerHTML = TIERS
        ? '<b>' + esc(nextRewardText(count)) + ' in this preview.</b> Want to add one before you head to the cart?'
        : '<b>One more for the wall?</b> Add another poster before you head to the cart.';
      recsEl.innerHTML = recs.map(function (p) {
        return '<div class="bd__rec">' +
          (p.image ? '<img src="' + esc(img(p.image, 120)) + '" alt="" loading="lazy">' : '<span></span>') +
          '<div>' +
            '<div class="bd__recname">' + esc(p.title) + '</div>' +
            '<div class="bd__recprice">from ' + fmt(p.variant.price) + ' &middot; ' + esc(p.variant.title) + '</div>' +
          '</div>' +
          '<button class="bd__recadd" type="button" data-bd-add="' + esc(p.variant.id) + '">Add</button>' +
        '</div>';
      }).join('');
      setMode('upsell');
      var first = recsEl.querySelector('.bd__recadd');
      if (first) first.focus();
    }

    /* ---------- wiring ---------- */

    function refresh() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render);
    }

    function open() { root.hidden = false; setMode('open'); refresh(); }
    function close() { setMode('collapsed'); if (lastCart) render(lastCart); }

    // Called by a page that has just added something. The bar rises into view
    // carrying the new poster and the next reward, and stays collapsed: the
    // customer is mid browse and a sheet over the page is not a confirmation,
    // it is an interruption.
    var flashTimer = null;
    function added() {
      if (mode !== 'collapsed') setMode('collapsed');
      // The bar is only revealed by render, once the new cart is actually in
      // hand. Revealing it first showed an empty bucket reading "0 posters,
      // total $0.00" for the length of the round trip, which is worse than
      // showing nothing: it says the add failed.
      return refresh().then(function () {
        if (root.hidden) return;
        barEl.classList.remove('bd__bar--flash');
        void barEl.offsetWidth;
        barEl.classList.add('bd__bar--flash');
        if (flashTimer) window.clearTimeout(flashTimer);
        flashTimer = window.setTimeout(function () { barEl.classList.remove('bd__bar--flash'); }, 1700);
      });
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-bd-collapse]')) { close(); return; }
      if (e.target.closest('[data-bd-upsell-close]')) { setMode('open'); return; }

      // Decline is a plain link to the cart; let the browser follow it.
      if (e.target.closest('[data-bd-decline]')) return;

      if (e.target.closest('[data-bd-toggle]')) {
        if (mode === 'collapsed') open(); else close();
        return;
      }

      var cta = e.target.closest('[data-bd-cta]');
      if (cta) {
        var count = lastCart ? unitsFrom(lastCart).length : 0;
        // Never block the road to checkout: only step in when the suggestions
        // are already in hand.
        // Test 2: the upsell no longer intercepts this button. It is now the
        // checkout button, and an interstitial in front of checkout was one
        // of the steps the 42.5% to 24.2% drop ran through.
        void count;
        return;
      }

      var add = e.target.closest('[data-bd-add]');
      if (add) {
        if (add.disabled) return;
        var label = add.textContent;
        add.disabled = true;
        add.textContent = 'Adding';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: add.dataset.bdAdd, quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            setMode('open');
            render(cart);
          })
          .catch(function () {
            add.disabled = false;
            add.textContent = label;
          });
        return;
      }

      var rm = e.target.closest('[data-bd-remove]');
      if (rm) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: rm.getAttribute('data-bd-remove'), quantity: 0 })
        }).then(function (r) { return r.json(); }).then(function (cart) {
          prevUnitCount = 0;
          render(cart);
        });
        return;
      }

      var dec = e.target.closest('[data-bd-dec]');
      var inc = e.target.closest('[data-bd-inc]');
      if (dec || inc) {
        var key = (dec || inc).dataset.bdDec || (inc).dataset.bdInc;
        var line = e.target.closest('.bd__card');
        var current = parseInt(line.querySelector('.bd__qnum').textContent, 10) || 0;
        var qty = dec ? Math.max(0, current - 1) : current + 1;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        }).then(function (r) { return r.json(); }).then(function (cart) {
          prevUnitCount = 0;
          render(cart);
        });
        return;
      }

      // Tapping the bar itself, away from any control, opens the sheet.
      if (mode === 'collapsed' && e.target.closest('[data-bd-bar]') && !e.target.closest('a, button, input')) open();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || root.hidden) return;
      // Escape steps back out of the upsell first, then closes the sheet.
      if (mode === 'upsell') { setMode('open'); return; }
      if (mode === 'open') close();
    });

    window.addEventListener('resize', function () {
      syncDock();
      if (!root.hidden) { syncPad(); scrollToNext(); }
    });

    document.addEventListener('prntd:bundle:open', open);
    document.addEventListener('prntd:bundle:added', added);
    /* The one tap add buttons on the cards are a separate layer and announce
       themselves as cart:refresh, which nothing here was listening for. So the
       cart grew and the bar kept showing the count it had read on page load:
       five posters and the same total no matter how many times you tapped
       plus. The bar is the running tally for the bundle offer, so a stale one
       is worse than none.

       cart:build is the same announcement from the drawer's own add path. */
    /* Debounced because the add layer announces on both document and window,
       so a single tap arrives here twice and would run two cart fetches. */
    var announceTimer = null;
    function onCartAnnounce() {
      if (announceTimer) window.clearTimeout(announceTimer);
      // Add paths announce cart:refresh and THEN ask for the sheet, so 60ms
      // later this used to collapse the sheet they had just opened. An open
      // sheet only needs its contents refreshed.
      announceTimer = window.setTimeout(function () {
        announceTimer = null;
        if (mode === 'open') refresh(); else added();
      }, 60);
    }
    ['cart:refresh', 'cart:build'].forEach(function (name) {
      document.addEventListener(name, onCartAnnounce);
      window.addEventListener(name, onCartAnnounce);
    });
    window.prntdBundleDrawer = { open: open, close: close, refresh: refresh, added: added };

    /* Step aside while the theme's cart drawer is open. Two carts were
       arguing over the same strip at the bottom of the screen, and the one
       the customer deliberately opened was the one losing: the bar sat over
       the drawer's own subtotal and checkout button.

       The bar exists to prompt opening the cart. While the cart is open it
       has nothing left to say. CSS handles the cases where the drawer marks
       itself open with an attribute or class; this watches actual visibility,
       because it is sometimes revealed by script alone. */
    (function yieldToDrawer() {
      var drawer = document.querySelector('cart-drawer, .drawer--cart');
      if (!drawer || !window.MutationObserver) return;
      /* Both axes and visibility. On phones the closed drawer is parked
         BELOW the screen (translateY 844, visibility hidden) at full width,
         so a left/right test alone read it as open and hid the bar on every
         page. That stayed latent while this ran inline before the drawer's
         styles applied; deferring the script exposed it. */
      var check = function () {
        var r = drawer.getBoundingClientRect();
        var cs = getComputedStyle(drawer);
        var open = !drawer.hidden && cs.visibility !== 'hidden' && cs.display !== 'none' &&
          r.width > 60 && r.right > 4 && r.left < window.innerWidth - 4 &&
          r.bottom > 4 && r.top < window.innerHeight - 4;
        root.classList.toggle('bd--yield', open);
      };
      // The attribute flips before the slide, so the drawer is still off
      // screen at that instant. Look again once it has landed.
      var settle = null;
      var checkSoon = function () {
        check();
        if (settle) window.clearTimeout(settle);
        settle = window.setTimeout(check, 450);
      };
      new MutationObserver(checkSoon).observe(drawer, {
        attributes: true,
        attributeFilter: ['class', 'open', 'hidden', 'style', 'aria-hidden']
      });
      drawer.addEventListener('transitionend', check);
      check();
    })();

    syncDock();

    // The bar is persistent, so it shows itself as soon as the cart has an item.
    refresh();
  })();
